import React, { useState, useEffect } from 'react';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import { InputText, ImageUpload, InputNumber } from 'components/common/input';
import { Alert } from 'react-bootstrap';
import useCrud from 'core/hooks/api/useCrud';
import { validateForm } from 'core/utils/validation';
import { useFormHandlers } from 'core/hooks/form/formHandlers';

const Information = () => {
    const {
        fetchData: data,
        fetchError: error,
        refetch,
        postData: createInformation,
        postError: creatingError,
        postLoading: creating,
        putData: updateInformation,
        putError: updatingError,
        putLoading: updating,
        clearErrors: clearServerErrors
    } = useCrud(API_ENDPOINTS.STORE_INFORMATION + '/1');

    const [formValues, setFormValues] = useState({
        facebook: '',
        instagram: '',
        twitter: '',
        whatsapp: '',
        phone_number: '',
        address: '',
        logo: '',
        ruc: ''
    });
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);

    useEffect(() => {
        if (data) {
            setFormValues(data);
        }
    }, [data]);

    const validationRules = [
        { field: 'facebook', method: ['validUrl'] },
        { field: 'instagram', method: [ 'validUrl'] },
        { field: 'twitter', method: ['validUrl'] },
        { field: 'whatsapp', method: 'required' },
    ];

    const { handleChange, handleFileChangeLocal } = useFormHandlers(setFormValues);

    const handleSave = async () => {
        setSuccessMessage(null);
        clearServerErrors();
        const formErrors = validateForm(formValues, validationRules);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }

        try {
            if (formValues.id) {
                await updateInformation(null, formValues, true);
                setSuccessMessage("Información actualizada con éxito.");
            } else {
                await createInformation(formValues, true);
                setSuccessMessage("Información creada con éxito.");
            }
            setErrors({});
            refetch();
        } catch (error) {
            console.error(error);
        }
    };

    if (error) return <p>Error: {error.message}</p>;

    return (
        <div>
            <div className="row w-100 mb-2">
                <div className="p-0 sub-title Service mb-2">
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <h5 className="m-0 text-title">Información</h5>
                        <button className="btn btn-primary" onClick={handleSave} disabled={updating || creating}>
                            <i className="fa fa-save me-2" aria-hidden="true" />
                            {updating || creating ? "Guardando..." : "Guardar Información"}
                        </button>
                    </div>
                </div>
                <hr className="mx-0" style={{ border: '2px', margin: '5px' }} />
            </div>
            {successMessage && <Alert variant="success">{successMessage}</Alert>}
            <div className="row">
                <div className="col-md-6 form-group">
                    <InputText
                        label="Facebook"
                        value={formValues.facebook}
                        onChange={(e) => handleChange('facebook', e.target.value)}
                        placeholder="Ingrese el enlace de Facebook"
                        error={errors.facebook}
                    />
                </div>
                <div className="col-md-6 form-group">
                    <InputText
                        label="Instagram"
                        value={formValues.instagram}
                        onChange={(e) => handleChange('instagram', e.target.value)}
                        placeholder="Ingrese el enlace de Instagram"
                        error={errors.instagram}
                    />
                </div>
                <div className="col-md-6 form-group">
                    <InputText
                        label="Tiktok"
                        value={formValues.twitter}
                        onChange={(e) => handleChange('twitter', e.target.value)}
                        placeholder="Ingrese el enlace de Tiktok"
                        error={errors.twitter}
                    />
                </div>
                <div className="col-md-6 form-group">
                    <InputNumber
                        label="WhatsApp"
                        value={formValues.whatsapp}
                        onChange={(e) => handleChange('whatsapp', e.value)}
                        placeholder="Ingrese el número de WhatsApp"
                        error={errors.whatsapp}
                    />
                </div>
                <div className="col-md-6 form-group">
                    <InputText
                        label="Información de contacto"
                        value={formValues.phone_number}
                        onChange={(e) => handleChange('phone_number',  e.target.value)}
                        placeholder="Ingrese la información de contacto"
                        error={errors.phone_number}
                    />
                </div>
                <div className="col-md-6 form-group">
                    <InputText
                        label="Dirección"
                        value={formValues.address}
                        onChange={(e) => handleChange('address', e.target.value)}
                        placeholder="Ingrese la dirección"
                        error={errors.address}
                    />
                </div>
                <div className="col-md-6 form-group">
                    <InputText
                        label="RUC"
                        value={formValues.ruc}
                        onChange={(e) => handleChange('ruc', e.target.value)}
                        placeholder="Ingrese el RUC"
                        error={errors.ruc}
                    />
                </div>
                {creatingError || updatingError ? (
                    <div className="col-12 form-group mt-3">
                        <Alert variant="danger">
                            {creatingError?.response?.data?.message || updatingError?.response?.data?.message}
                        </Alert>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default React.memo(Information);